import { useCallback, useEffect, useState } from "react";
import useAutoFocus from "./useAutoFocus";
import stringUtils from "../_services/string-utils";

const usePathwayInputGroup = (
    name,
    value,
    shouldBeFilled,
    submitted,
    autoFocus,
    triggerOnBlur,
    inputValidation,
    onChange
) => {
    const [valid, setValid] = useState(true);

    const [mandatory, setMandatory] = useState(false);
    const [isNotFilled, setIsNotFilled] = useState(false);
    const [blurredAfterInvalid, setBlurredAfterInvalid] = useState(false);
    const inputRef = useAutoFocus(name, value, autoFocus);

    const applyOnBlurFunctions = useCallback(
        (value) => {
            if (triggerOnBlur) {
                value = triggerOnBlur(value);
            }
            if (mandatory && stringUtils.isBlank(value)) {
                setValid(false);
            } else {
                setValid(true);
            }
            setIsNotFilled(stringUtils.isBlank(value));

            if (inputValidation) {
                if (!inputValidation(value) && !mandatory && stringUtils.isBlank(value)) {
                    setValid(true);
                } else if (inputValidation(value)) {
                    setValid(true);
                } else {
                    setValid(false);
                }
            }
            return value;
        },
        [inputValidation, mandatory, triggerOnBlur]
    );

    const onBlur = (e) => {
        e.target.value = applyOnBlurFunctions(e.target.value);

        if (inputValidation && !inputValidation(e.target.value) && !mandatory && stringUtils.isBlank(e.target.value)) {
            //do Nothing
        } else if (inputValidation && !inputValidation(e.target.value)) {
            setBlurredAfterInvalid(true);
        }
        if (mandatory && stringUtils.isBlank(e.target.value)) {
            setValid(false);
            setBlurredAfterInvalid(true);
        }

        if (
            !stringUtils.equals(String(e.target.value), String(value)) &&
            !(stringUtils.isBlank(String(e.target.value)) && stringUtils.isBlank(String(value)))
        ) {
            handleChange(e);
        }
    };

    const handleChange = (e) => {
        if (!e.target.validity.valid) {
            return;
        }
        if (blurredAfterInvalid || !valid || triggerOnBlur) {
            e.target.value = applyOnBlurFunctions(e.target.value);
        }

        onChange(e);
    };

    useEffect(() => {
        if (submitted) {
            applyOnBlurFunctions(value);
        }
    }, [submitted, applyOnBlurFunctions, value]);

    useEffect(() => {
        if (shouldBeFilled) {
            setMandatory(shouldBeFilled);
        }
    }, [shouldBeFilled]);

    return {
        valid,
        blurredAfterInvalid,
        mandatory,
        isNotFilled,
        handleChange,
        onBlur,
        inputRef,
    };
};

export default usePathwayInputGroup;
